const dirtySources = new Set<symbol>();

export const setUnsavedPostInput = (source: symbol, isDirty: boolean) => {
  if (isDirty) {
    dirtySources.add(source);
    return;
  }

  dirtySources.delete(source);
};

export const clearUnsavedPostInput = (source: symbol) => {
  dirtySources.delete(source);
};

export const hasUnsavedPostInput = () => dirtySources.size > 0;
